import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  CircularProgress,
} from '@mui/material';

const ScanningDialog = ({ open, onComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (open) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress(prev => {
          const newProgress = prev + 10;
          if (newProgress >= 100) {
            clearInterval(interval);
            onComplete?.();
            return 100;
          }
          return newProgress;
        });
      }, 200);  // 每200ms更新一次，总共2秒完成

      return () => clearInterval(interval);
    }
  }, [open, onComplete]);

  return (
    <Dialog 
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
          maxWidth: '400px'
        }
      }}
    >
      <DialogContent sx={{ 
        p: '40px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '250px'
      }}>
        <CircularProgress 
          variant="determinate" 
          value={progress}
          size={60}
          thickness={4}
          sx={{ mb: 3 }}
        />
        <Typography variant="h6" sx={{ mb: 1 }}>
          Scanning Document
        </Typography>
        <Typography color="text.secondary">
          Please wait while we process your document... {progress}%
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ScanningDialog; 